/*global window, jQuery, shop */
(function($) {

  'use strict';

  function detectmob() { 
     if( navigator.userAgent.match(/Android/i)
     || navigator.userAgent.match(/webOS/i)
     || navigator.userAgent.match(/iPhone/i)
     || navigator.userAgent.match(/iPad/i)
     || navigator.userAgent.match(/iPod/i)
     || navigator.userAgent.match(/BlackBerry/i)
     || navigator.userAgent.match(/Windows Phone/i)
     || (navigator.userAgent.match(/Mac/i) && "ontouchstart" in document.documentElement)
     ){
        return true;
      }
     else {
        return false;
      }
    }

  $(document).ready(function(){
    $('.loading-link').on('click', function(){
      $('#loading').show();
    });

    $('#loading').hide();
  });
  
  $(function() {



    $('[data-toggle="tooltip"]').tooltip();

    $('.lista_categorie > li:first-child').addClass('active');
    $('.lista_categorie > li').click(function() {
      if (detectmob()){
      
      } else {
        var idCat = $(this).data('categoria');
        $('.lista_categorie li').removeClass('active');
        $(this).addClass('active');
        $('#menuCategoria' + idCat).show().siblings().hide();
        return false;
      }
    });

    $('.btn_categorie').on('click', function(){
      $('.max-width').toggle();
      $('.ba-toggle').toggleClass('active')
      $('.max-width').width($('.container').width());
      $('.col-cat').width($('.btn_categorie').width() - (parseInt($('.col-cat').css('padding'))*2)-2);
      $('.col-sub-cat').width($('.max-width').width() -10 - $('.col-cat').width() - (parseInt($('.col-sub-cat').css('padding'))*2)- (parseInt($('.col-cat').css('padding'))*2));
    });

    $(window).resize(function(){
      $('.max-width').width($('.container').width());
      $('.col-cat').width($('.btn_categorie').width() - (parseInt($('.col-cat').css('padding'))*2)-2);
      $('.col-sub-cat').width($('.max-width').width() -10 - $('.col-cat').width() - (parseInt($('.col-sub-cat').css('padding'))*2)- (parseInt($('.col-cat').css('padding'))*2));
    })

    const getSuggerimenti = (keyword) => {
      $.ajax({
        dataType: 'json',
        type: 'POST',
        url: '/ajax/ricerca.php',
        data: {
          keyword: keyword
        },
        success: function(suggerimenti) {
          if (suggerimenti[0]['errore']) {
          	$('#container-risultato').hide();
          } else {
          	$('#container-risultato').show();
          	$('#risultato').html(suggerimenti[0]['risultato']);
          }
        }
      });
    }

    function delay(callback, ms) {
      var timer = 0;
      return function() {
        var context = this, args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
          callback.apply(context, args);
        }, ms || 0);
      };
    }

    $('#inputCerca').keyup(delay(function (e) {

  		var key =  $(this).val();
  		if (key.length > 1) {	
  		 	getSuggerimenti(key);
  		} else {
  			getSuggerimenti('NORESULT');
  		}
    }, 800));

    $('#inputCerca').keypress(function(event){
        var keycode = (event.keyCode ? event.keyCode : event.which);
        if(keycode == '13'){
            var keyword = $('#inputCerca').val();
            document.location.href = '/it/risultato/?keyword=' + keyword;
        }
    });

    $('.btn-cerca').on('click', function(){
      var keyword = $('#inputCerca').val();
      if (keyword.length > 1) document.location.href = '/it/risultato/?keyword=' + keyword;
    });

  	var bLazy = new Blazy({
  		selector: '.b-lazy'
  	});

    $('.stickyheader').sticky({topSpacing:0});

    $('.stickyProd').sticky({topSpacing:($('.stickyheader').offset().top + 55), zIndex:9999});
    
    $('.stickyAzienda').sticky({topSpacing:($('.stickyheader').height()), zIndex:9999});
    


    $('body').on('click', '*', 
      delay(function (e) {
          if (window.shop.isLoggedIn) {
            $.ajax({
              dataType: 'json',
              type: 'POST',
              url: '/shop/ajax/shop.php',
              data: {
                action: 'check-session'
              },
              success: function(ret) {
                if (!ret) {
                  location.href = '/';
                } else {
                  //console.log('utente-loggato');
                }
              }
            });
          }
      }, 300)
    );


  });

  

}(jQuery));
